import React, { useState, useEffect } from 'react';
import { Pages } from './types/Pages';
import { AppContext } from './context/appContext';
import { isIdentified } from './api/user';
import Login from './forms/Login';
import Snackbar from '@mui/material/Snackbar';
import { Alert, Box } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Navigation } from '@toolpad/core';
import HomeIcon from '@mui/icons-material/Home';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import GroupIcon from '@mui/icons-material/Group';
import SignLanguageIcon from '@mui/icons-material/SignLanguage';
import SettingsIcon from '@mui/icons-material/Settings';
import { Theme } from './themes/Theme';
import { ReactRouterAppProvider } from '@toolpad/core/react-router';
import { Outlet } from 'react-router';
import logo from './assets/angeluzzo_logo.jpg'
import { RESTAURANT_FULLNAME } from './tools/constants';
import HistoryIcon from '@mui/icons-material/History';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import { UserRole } from './types/AppContext.d';

function getNavbar(userRole: UserRole | string | null): Navigation {

	const configPages = [
		{
			kind: 'divider',
		},
		{
			kind: 'header',
			title: 'Configuration',
		},
		{
			segment: 'formations',
			title: 'Formations',
			icon: <SignLanguageIcon />,
		},
		{
			segment: 'utilisateurs',
			title: 'Utilisateurs',
			icon: <SupervisorAccountIcon />,
		},
		{
			segment: 'parametres',
			title: 'Paramètres',
			icon: <SettingsIcon />,
		}
	] as const


	return [
		{
			kind: 'header',
			title: 'Accueil',
		},
		{
			segment: '',
			title: 'Dashboard',
			icon: <HomeIcon />,
		},
		{
			kind: 'divider',
		},
		{
			kind: 'header',
			title: 'Planification',
		},
		{
			segment: 'planning',
			title: 'Planning',
			icon: <CalendarMonthIcon />,
		},
		{
			segment: 'besoins-reguliers',
			title: 'Besoins réguliers',
			icon: <HistoryIcon sx={{ color: 'primary.main' }} />,
		},
		{
			kind: 'divider',
		},
		{
			kind: 'header',
			title: 'Gestion',
		},
		{
			segment: 'performances',
			title: 'Performances',
			icon: <QueryStatsIcon />,
		},
		{
			segment: 'equipe',
			title: 'Equipe',
			icon: <GroupIcon />,
		},
		...(userRole === UserRole.SUPERADMIN ? configPages : []),
	]
}


function App() {
	const [navigation, setNavigation] = useState<Navigation>([]);
	const [page, setPage] = useState(Pages.none);
	const [snackbar, setSnackbar] = useState({ open: false, message: '', color: 'info' as 'info' | 'success' | 'error' });

	const showSnack = (message: string, color: 'info' | 'success' | 'error') => {
		setSnackbar({ open: true, message: message, color: color });
	};

	const [identified, setIdentified] = useState(false);
	const [userRole, setUserRole] = useState<UserRole | null>(null);
	useEffect(() => {
		const checkIdentification = async () => {
			const res = await isIdentified();
			console.log(res)
			setIdentified(res.identified);
			if(res.role){
				setUserRole((res.role.label as UserRole));
				setNavigation(getNavbar(res.role.label));
			}
		};
		checkIdentification()
	}, [identified, page]);

	return (
		<ReactRouterAppProvider
			branding={{
				homeUrl: './',
				title: RESTAURANT_FULLNAME,
				logo: <img src={logo} alt="Logo" style={{ height: 40 }} />
			}}
			navigation={navigation}
			theme={Theme}
		>
			<LocalizationProvider
				dateAdapter={AdapterDayjs}
				adapterLocale="fr"
			>
				<AppContext.Provider value={{ setPage: setPage, showSnackbar: showSnack, userRole: userRole }}>
					{
						identified ?
							(
								<>

									<Box sx={{ padding: 0, margin: 0 }}>
										<Outlet />
									</Box>
								</>
							)
							:
							<div className='w-full h-full fixed z-50'>
								<Login />
							</div>
					}

					{/* Global snackbar */}
					<Snackbar
						anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
						open={snackbar.open}
						onClose={() => { setSnackbar({ open: false, message: '', color: 'info' }) }}
						key={'1'}
						autoHideDuration={4000}
					>
						<Alert severity={snackbar.color} >
							{snackbar.message}
						</Alert>
					</Snackbar>


					{/* {
            identified?
            (
              <>
                <Button
                  sx={{
                      position: 'fixed',
                      bottom: 32,
                      right: 32,
                      width: 64,
                      height: 64,
                      borderRadius: '50%',
                      boxShadow: 3,
                      zIndex: 1050
                    }}
                  variant="contained"
                  onClick={handleClick}
                >
                  <ChatBubbleOutlineIcon/>
                </Button>

                  {/* Chatbox popper * /}
                  <Popper open={open} anchorEl={anchorEl} placement='left-end' >
                    <Chatboxv2 closeChat={handleClick} employees={employees} setEmployees={setEmployees} />
                  </Popper>
                </>
              )
            :
            null
          } */}


				</AppContext.Provider>
			</LocalizationProvider>
		</ReactRouterAppProvider>
	);
}

export default App;
